import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import axiosLogin from "global/helpers/axiosLogin";
import {
  GET_TURNOS,
  GET_TURNOS_FAIL,
  GET_TURNOS_SUCCESS,
} from "../ActionTypes";

export const wsGetTurnosConPresenteQr = (next) => (dispatch) => {
  // trae los turnos de hoy
  dispatch({ type: GET_TURNOS });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/turnos/turnosPacienteDelDia/conPresente`)
      .then((resp) => {
        dispatch({ type: GET_TURNOS_SUCCESS, payload: resp.data });
        if (next) next(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: GET_TURNOS_FAIL, payload: err });
        if (next) next(false);
      });
  });
};

export const wsGetTurnosPacienteDelDiaQr = (next) => (dispatch) => {
  // trae los turnos de hoy
  dispatch({ type: GET_TURNOS });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/turnos/turnosPacienteDelDia`)
      .then((resp) => {
        let data = resp.data;
        data = data.map((element) => {
          return {
            idturno: element["idturno"],
            idMedico: element["idMedico"],
            idRecepcion: element["idRecepcion"],
            idCentro: element["idCentro"],
            medico: element["medico"],
            fecha: element["fecha"],
            hora: element["hora"],
            especialidad: element["especialidad"],
            idEspecialidad: element["idEspecialidad"],
            centro: element["centro"],
            checkin: element["checkin"],
            flgSaldada: element["flgSaldada"],
            coordenadaGps: element["coordenadaGps"],
            selected: true,
            idProtocolo: element["idProtocolo"],
            presente: element["presente"],
            flgSoloConsulta: element["flgSoloConsulta"],
            flgSoloPractica: element["flgSoloPractica"],
            consultorio: element["consultorio"],
            piso: element["piso"],
            ausente: element["ausente"],
            asucargo: element["asucargo"],
            sinFirmaPacOrdenTurno: element["sinFirmaPacOrdenTurno"],
            sinFirmaPacOrdenLabo: element["sinFirmaPacOrdenLabo"],
            requiereAutorizacion: element["requiereAutorizacion"],
            estadoProtocolo: element["estadoProtocolo"],
            kinesioVerificaRecepcion: element["kinesioVerificaRecepcion"],
            osValidacionInterna: element["osValidacionInterna"],
            tieneFotoOrden: element["tieneFotoOrden"],
            obra_social: element["obra_social"],
            cobertura: element["coberturaDto"],
            resumen: {
              validaOnlineEstado: element["validaOnlineEstado"],
              validaOnline: element["validaOnline"],
              monto: element["monto"],
              medSolicitanteDto: element["medSolicitanteDto"],
              estadoOrden: element["estadoOrden"],
              tieneDeterminaciones: element["tieneDeterminaciones"],
            },
          };
        });
        dispatch({ type: GET_TURNOS_SUCCESS, payload: data });
        if (next) next(true, data);
      })
      .catch((err) => {
        dispatch({ type: GET_TURNOS_FAIL, payload: err });
        if (next) next(false);
      });
  });
};

export const wsGetTurnoByIdQr = (idTurno, next) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/turnos/${idTurno}/-1`)
      .then((resp) => {
        let element = resp.data;
        let data = {
          idturno: element["idturno"],
          idMedico: element["idMedico"],
          medico: element["medico"],
          fecha: element["fecha"],
          hora: element["hora"],
          especialidad: element["especialidad"],
          centro: element["centro"],
          checkin: element["checkin"],
          flgSaldada: element["flgSaldada"],
          coordenadaGps: element["coordenadaGps"],
          selected: true,
          idProtocolo: element["idProtocolo"],
          presente: element["presente"],
          flgSoloConsulta: element["flgSoloConsulta"],
          flgSoloPractica: element["flgSoloPractica"],
          faltaValidarConsulta: element["faltaValidarConsulta"],
          faltaValidarPracticas: element["faltaValidarPracticas"],
          consultorio: element["consultorio"],
          ausente: element["ausente"],
          requiereAutorizacion: element["requiereAutorizacion"],
          kinesioVerificaRecepcion: element["kinesioVerificaRecepcion"],
          osValidacionInterna: element["osValidacionInterna"],
          idEspecialidad: element["idEspecialidad"],
          tieneFotoOrden: element["tieneFotoOrden"],
          cobertura: element["coberturaDto"],
          resumen: {
            validaOnlineEstado: element["validaOnlineEstado"],
            validaOnline: element["validaOnline"],
            monto: element["monto"],
            medSolicitanteDto: element["medSolicitanteDto"],
            estadoOrden: element["estadoOrden"],
            tieneDeterminaciones: element["tieneDeterminaciones"],
          },
        };
        if (next) next(true, data);
      })
      .catch((err) => {
        console.error("[CheckinQR] wsGetTurnoByIdQr FALLÓ", {
          idTurno,
          status: err?.response?.status,
          error: err?.response?.data,
        });
        if (next) next(false);
      });
  }).catch((err) => {
    console.error("[CheckinQR] axiosLogin falló en wsGetTurnoByIdQr", {
      idTurno,
      error: err?.message,
    });
    if (next) next(false);
  });
};

export const setTurnoForced = (turno) => (dispatch) => {
  dispatch({ type: GET_TURNOS_SUCCESS, payload: turno });
};
